import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { BootstrapAlert } from "../../components/BootstrapAlert";
import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner";

// services
import {
  useGetTrainingMenuBasedOnModuleQuery,
  useUpdateModuleStatusMutation,
  useBookmarkModuleMutation,
} from "../../store/services/moduleServerApi";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const navigate = useNavigate();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  /* Start useState */

  const [skipGetTrainingMenu, setSkipGetTrainingMenu] = useState(false);

  /* End useState */

  const { isLoading: isMenuFetched } = useGetTrainingMenuBasedOnModuleQuery(5, {
    skip: skipGetTrainingMenu,
  });

  const [
    updateModuleStatus,
    {
      isLoading,
      status: updateStatus,
      error: { data: { message: errorMessage } = {} } = {},
    },
  ] = useUpdateModuleStatusMutation();

  const [bookmarkModule, { status: bookmarkStatus }] =
    useBookmarkModuleMutation();

  if (bookmarkStatus === "fulfilled") {
    navigate("/module-5/indications");
  }
  /* Start useEffect */

  useEffect(() => {
    if (updateStatus === "fulfilled") {
      bookmarkModule({ pathName });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateStatus]); // * onUpdateMenu Status
  /* End useEffect */

  const handleStartModuleFive = () => {
    setSkipGetTrainingMenu(true);
    updateModuleStatus({ moduleNo: 5, start: 1 });
  };

  return (
    <div className="row">
      {isMenuFetched && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <div className="module-content">
          <h1 className="blue text-uppercase b mt-5 mb-4">
            REPORTING MODULE (optional)
          </h1>
          <p className="d-inline me-4 b">20 Minutes</p>
          <p className="d-inline me-4 b">English</p>

          <h2 className="b mt-4 text-uppercase">
            <span className="orange">Learn how to support your patients</span>{" "}
            by effectively reporting <br /> Scans
          </h2>
          <p className="mt-4">
            Welcome to the Amyvid<sup>&reg;</sup> (Florbetapir F 18 Injection)
            Reporting Module. Here, you'll find training that supports best
            practices for radiologists in reporting Amyvid scan results to
            referring physicians and for referring physicians on assessing and
            sharing scan reports.{" "}
          </p>
          <article className="mt-5">
            <h3 className="b mb-3">In this module</h3>
            <ul>
              <li>Indication and Limitations of Use </li>
              <li>Important Safety Information </li>
              <li>
                Chapter 1: Importance of reporting standardization and report
                template components
              </li>
              <li>
                Chapter 2: Recommended practices on sharing results back to
                patients
              </li>
            </ul>
          </article>
          <article className="mt-5 mb-5">
            <h3 className="b mb-3">Focused Learning Objectives</h3>
            <h5 className="mb-3">For Radiologists</h5>
            <ul>
              <li>Working within the standardized reporting template </li>
              <li>Utilizing key scan report components </li>
              <li>
                Methods in communicating Amyvid PET scan results to referring
                physicians
              </li>
            </ul>
            <h5 className="mb-3">For Referring Physicians</h5>
            <ul>
              <li>
                Better understand how to assess Amyvid PET scan results and
                share them back to patients with clear communication{" "}
              </li>
              <li>Review best practices for communicating amyloid PET scan results to patients</li>
            </ul>
          </article>

          <BootstrapAlert variant="danger" message={errorMessage} />
          <LdsButton
            className="blue-button mt-3 mb-5"
            disabled={isLoading}
            onClick={handleStartModuleFive}
          >
            Start Module Now
          </LdsButton>
        </div>
      </main>
    </div>
  );
};

export default Module_1_0;
